import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Selectors
import { makeSelectPreviousEntityTypeValue } from '../../services/entityTypes/selectors';

interface OwnProps {
    entityTypeId: number;
    plural?: boolean;
    children?: React.ReactElement<any> | Function;
}

interface ConnectedProps {
    name?: string;
    pluralName?: string;
}

type Props = OwnProps & ConnectedProps;

export class EntityTypeParentName extends React.PureComponent<Props> {
    get name() {
        const { name, plural, pluralName } = this.props;
        return plural ? pluralName : name;
    }

    render() {
        const { children } = this.props;

        if (children instanceof Function) {
            return children(this.name);
        }

        if (children) {
            return React.cloneElement(children as React.ReactElement<any>, {
                entityTypeName: this.name
            });
        }

        return this.name || null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, OwnProps, ConnectedProps>({
    name: makeSelectPreviousEntityTypeValue('name'),
    pluralName: makeSelectPreviousEntityTypeValue('pluralName')
});

// <State, Dispatch, OwnProps, StateProps, DispatchProps>
export default connect(mapStateToProps)(EntityTypeParentName);
